export function buildDistractorExponents({
  K,
  K_top,
  K_bottom,
  e1,
  e2,
}) {
  const distractorExps = new Set();
  const candidateExps = [
    K_top + K_bottom, // Adds exponents instead of subtracting them.
    e1 - e2, // Skips conversion to a common base.
    K_top, // Ignores the denominator.
    -K, // Reverses the sign of the result.
    K + 1,
    K - 1,
    K + 2,
    K - 2,
  ];

  for (const cand of candidateExps) {
    if (
      distractorExps.size >= 3 ||
      cand === K ||
      Math.abs(cand) > 12 ||
      cand === 0
    ) {
      continue;
    }
    distractorExps.add(cand);
  }

  return distractorExps;
}
